/*
 * Henry Cavendish Glossary Popup
 */

(function () {
  'use strict';

  let glossaryData = null;
  let lastTrigger = null;

  console.log('HC glossary JS loaded');

  async function loadGlossary() {
    if (glossaryData) {
      return glossaryData;
    }

    if (!window.HC_GLOSSARY_URL) {
      throw new Error('HC_GLOSSARY_URL is not defined.');
    }

    const response = await fetch(window.HC_GLOSSARY_URL);

    if (!response.ok) {
      throw new Error(
        `Glossary JSON failed to load: ${response.status}`
      );
    }

    glossaryData = await response.json();

    console.log(
      'HC glossary loaded:',
      Object.keys(glossaryData.terms || {}).length,
      'terms'
    );

    return glossaryData;
  }

function setupPopupSearch(modal) {

  const input = modal.querySelector(
    '[data-hc-popup-search]'
  );

  const results = modal.querySelector(
    '[data-hc-popup-results]'
  );

  if (!input || !results) {
    return;
  }

  input.addEventListener(
    'input',
    async function () {

      const query =
        input.value.trim().toLowerCase();

      if (!query) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      const glossary =
        await loadGlossary();

      const matches =
        Object.values(glossary.terms || {})
          .filter(function (entry) {

            const text = [
              entry.term,
              ...(entry.aliases || []),
              entry.definition
            ]
              .join(' ')
              .toLowerCase();

            return text.includes(query);
          })
          .slice(0, 8);

      if (!matches.length) {
        results.innerHTML =
          '<p class="hc-glossary-modal__no-results">No matching terms found.</p>';

        results.hidden = false;
        return;
      }

      results.innerHTML =
        matches.map(function (entry) {

          return `
            <button
              type="button"
              class="hc-glossary-search-result"
              data-glossary-term="${entry.handle}">
              ${entry.term}
            </button>
          `;

        }).join('');

      results.hidden = false;
    }
  );
}

  function createModal() {

    let modal = document.getElementById(
      'hc-glossary-modal'
    );

    if (modal) {
      return modal;
    }

    modal = document.createElement('div');

    modal.id = 'hc-glossary-modal';
    modal.className = 'hc-glossary-modal';
    modal.hidden = true;

    modal.innerHTML = `
      <div
        class="hc-glossary-modal__backdrop"
        data-hc-glossary-close>
      </div>

      <div
        class="hc-glossary-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hc-glossary-title">

        <button
          type="button"
          class="hc-glossary-modal__close"
          data-hc-glossary-close
          aria-label="Close glossary definition">
          &times;
        </button>

        <p class="hc-glossary-modal__eyebrow">
          A GENTLEMAN'S WET SHAVING GLOSSARY
        </p>
<div class="hc-glossary-modal__search">
  <input
    type="search"
    placeholder="Search the glossary..."
    aria-label="Search the glossary"
    data-hc-popup-search
  >
</div>

<div
  class="hc-glossary-modal__results"
  data-hc-popup-results
  hidden>
</div>
        <h2
          id="hc-glossary-title"
          class="hc-glossary-modal__title">
        </h2>

        <div class="hc-glossary-modal__body">
        </div>

      </div>
    `;

    document.body.appendChild(modal);
    setupPopupSearch(modal);

    modal.addEventListener(
      'click',
      function (event) {

        if (
          event.target.closest(
            '[data-hc-glossary-close]'
          )
        ) {
          closeModal();
        }

      }
    );

    return modal;
  }


  function closeModal() {

    const modal = document.getElementById(
      'hc-glossary-modal'
    );

    if (!modal) {
      return;
    }

    modal.hidden = true;

    document.body.classList.remove(
      'hc-glossary-open'
    );

    if (lastTrigger) {
      lastTrigger.focus();
    }
  }

function escapeRegex(value) {
  return String(value).replace(
    /[.*+?^${}()|[\]\\]/g,
    '\\$&'
  );
}

function highlightSearchText(
  value,
  query
) {

  if (!query) {
    return value;
  }

  const regex = new RegExp(
    `(${escapeRegex(query)})`,
    'gi'
  );

  return String(value).replace(
    regex,
    '<mark class="hc-search-highlight">$1</mark>'
  );
}

  function openModal(entry, trigger) {

    const modal = createModal();

    const title = modal.querySelector(
      '.hc-glossary-modal__title'
    );

    const body = modal.querySelector(
      '.hc-glossary-modal__body'
    );

    const searchInput = modal.querySelector(
  '[data-hc-popup-search]'
    );

    const searchQuery = searchInput
      ? searchInput.value.trim()
      : '';

    title.textContent = entry.term;

    let html = '';

    if (
      entry.aliases &&
      entry.aliases.length
    ) {

      html += `
        <p class="hc-glossary-modal__aliases">
          <strong>Also known as:</strong>
          ${entry.aliases.join(', ')}
        </p>
      `;
    }


    html += `
      <div class="hc-glossary-modal__section">

        <h3>Definition</h3>

        <p>
 ${highlightSearchText(
  entry.definition,
  searchQuery
)}
        </p>

      </div>
    `;


    html += `
      <div class="hc-glossary-modal__section">

        <h3>Why it matters</h3>

        <p>
${highlightSearchText(
  entry.why_it_matters,
  searchQuery
)}
        </p>

      </div>
    `;


    if (entry.introduced_in) {

 html += `
  <div class="hc-glossary-modal__section">

    <h3>First introduced in</h3>

    <p>
      <a
        href="${entry.introduced_in.url}"
        target="_blank"
        rel="noopener">
        Chapter ${entry.introduced_in.number}
        — ${entry.introduced_in.title}
      </a>
    </p>

  </div>
    `;
    }


    if (
      entry.expanded_in &&
      entry.expanded_in.length
    ) {

      html += `
        <div class="hc-glossary-modal__section">

          <h3>Also discussed in</h3>

          <ul>
      `;

      entry.expanded_in.forEach(
        function (chapter) {

          html += `
            <li>
              <a href="${chapter.url} target="_blank">
                Chapter ${chapter.number}
                — ${chapter.title}
              </a>
            </li>
          `;

        }
      );

      html += `
          </ul>

        </div>
      `;
    }


    if (
      entry.related &&
      entry.related.length
    ) {

      html += `
        <div class="hc-glossary-modal__section">

          <h3>Related terms</h3>

          <div class="hc-glossary-modal__related">
      `;

      entry.related.forEach(
        function (related) {

          if (related.handle) {

            html += `
              <button
                type="button"
                class="hc-glossary-related"
                data-glossary-term="${related.handle}">
                ${related.term}
              </button>
            `;

          } else {

            html += `
              <span class="hc-glossary-related">
                ${related.term}
              </span>
            `;
          }

        }
      );

      html += `
          </div>

        </div>
      `;
    }



    body.innerHTML = html;

    lastTrigger = trigger;

    modal.hidden = false;

    document.body.classList.add(
      'hc-glossary-open'
    );

    const closeButton = modal.querySelector(
      '.hc-glossary-modal__close'
    );

    if (closeButton) {
      closeButton.focus();
    }
  }


  async function openTerm(
    handle,
    trigger
  ) {

    try {

      const glossary = await loadGlossary();

      const entry =
        glossary.terms &&
        glossary.terms[handle];

      if (!entry) {

        console.warn(
          'Glossary term not found:',
          handle
        );

        return;
      }

      openModal(
        entry,
        trigger
      );

    } catch (error) {

      console.error(
        'HC Glossary:',
        error
      );
    }
  }


  document.addEventListener(
    'click',
    function (event) {

      const trigger = event.target.closest(
        '[data-glossary-term]'
      );

      if (!trigger) {
        return;
      }

      event.preventDefault();

      const handle =
        trigger.dataset.glossaryTerm;

      if (!handle) {
        return;
      }
document
  .querySelectorAll('.hc-glossary-search-result--active')
  .forEach(function (item) {
    item.classList.remove(
      'hc-glossary-search-result--active'
    );
  });


if (
  trigger.classList.contains(
    'hc-glossary-search-result'
  )
) {
  trigger.classList.add(
    'hc-glossary-search-result--active'
  );
}
      openTerm(
        handle,
        trigger
      );
    }
  );


  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {
        closeModal();
      }

    }
  );
/* =========================================================
   FULL GLOSSARY PAGE
   ========================================================= */

function setupGlossaryPage() {

  const input =
    document.querySelector(
      '[data-hc-page-search]'
    );

  const results =
    document.querySelector(
      '[data-hc-page-results]'
    );

  const viewer =
    document.querySelector(
      '[data-hc-page-viewer]'
    );

  if (!input || !results || !viewer) {
    return;
  }

  console.log('HC glossary page search ready');


  async function showPageEntry(
    handle,
    trigger
  ) {

    const glossary =
      await loadGlossary();

    const entry =
      glossary.terms &&
      glossary.terms[handle];

    if (!entry) {
      console.warn(
        'Glossary page term not found:',
        handle
      );
      return;
    }


    /* clear old active pill */

    results
      .querySelectorAll(
        '.hc-glossary-search-result--active'
      )
      .forEach(function (item) {

        item.classList.remove(
          'hc-glossary-search-result--active'
        );

      });


    /* mark clicked result active */

    if (
      trigger &&
      trigger.classList.contains(
        'hc-glossary-search-result'
      )
    ) {

      trigger.classList.add(
        'hc-glossary-search-result--active'
      );
    }


    const query =
      input.value.trim();


    let html = `

      <article class="hc-glossary-page-entry">

        <h2
          class="hc-glossary-page-entry__title">

          ${entry.term}

        </h2>
    `;


    if (
      entry.aliases &&
      entry.aliases.length
    ) {

      html += `

        <p class="hc-glossary-modal__aliases">

          <strong>Also known as:</strong>
          ${entry.aliases.join(', ')}

        </p>
      `;
    }


    html += `

      <div class="hc-glossary-modal__section">

        <h3>Definition</h3>

        <p>
          ${
            highlightSearchText(
              entry.definition,
              query
            )
          }
        </p>

      </div>


      <div class="hc-glossary-modal__section">

        <h3>Why it matters</h3>

        <p>
          ${
            highlightSearchText(
              entry.why_it_matters,
              query
            )
          }
        </p>

      </div>
    `;


    if (entry.introduced_in) {

      html += `

        <div class="hc-glossary-modal__section">

          <h3>First introduced in</h3>

          <p>

            <a
              href="${entry.introduced_in.url}"
              target="_blank"
              rel="noopener">

              Chapter ${entry.introduced_in.number}
              — ${entry.introduced_in.title}

            </a>

          </p>

        </div>
      `;
    }


    if (
      entry.expanded_in &&
      entry.expanded_in.length
    ) {

      html += `

        <div class="hc-glossary-modal__section">

          <h3>Also discussed in</h3>

          <ul>
      `;


      entry.expanded_in.forEach(
        function (chapter) {

          html += `

            <li>

              <a
                href="${chapter.url}"
                target="_blank"
                rel="noopener">

                Chapter ${chapter.number}
                — ${chapter.title}

              </a>

            </li>
          `;

        }
      );


      html += `

          </ul>

        </div>
      `;
    }


    if (
      entry.related &&
      entry.related.length
    ) {

      html += `

        <div class="hc-glossary-modal__section">

          <h3>Related terms</h3>

          <div class="hc-glossary-modal__related">
      `;


      entry.related.forEach(
        function (related) {

          if (related.handle) {

            html += `

              <button
                type="button"
                class="hc-glossary-related"
                data-hc-page-term="${related.handle}">

                ${related.term}

              </button>
            `;

          }

        }
      );


      html += `

          </div>

        </div>
      `;
    }


    html += `
      </article>
    `;


    viewer.innerHTML = html;
    viewer.hidden = false;


    history.replaceState(
      null,
      '',
      '#' + entry.handle
    );
  }


  /* search */

  input.addEventListener(
    'input',
    async function () {

      const query =
        input.value
          .trim()
          .toLowerCase();


      results.innerHTML = '';


      if (!query) {

        results.hidden = true;
        viewer.hidden = true;

        return;
      }


      const glossary =
        await loadGlossary();


      const matches =
        Object.values(
          glossary.terms || {}
        )
          .filter(function (entry) {

            const text = [

              entry.term,

              ...(entry.aliases || []),

              entry.definition,

              entry.why_it_matters

            ]
              .join(' ')
              .toLowerCase();


            return text.includes(
              query
            );

          })
          .slice(0, 12);


      if (!matches.length) {

        results.innerHTML =
          '<p class="hc-glossary-modal__no-results">No matching terms found.</p>';

        results.hidden = false;

        return;
      }


      results.innerHTML =
        matches.map(
          function (entry) {

            return `

              <button
                type="button"
                class="hc-glossary-search-result"
                data-hc-page-term="${entry.handle}">

                ${entry.term}

              </button>
            `;

          }
        ).join('');


      results.hidden = false;
    }
  );


  /* result + related-term clicks */

  document.addEventListener(
    'click',
    function (event) {

      const trigger =
        event.target.closest(
          '[data-hc-page-term]'
        );

      if (!trigger) {
        return;
      }


      event.preventDefault();


      const handle =
        trigger.dataset.hcPageTerm;


      if (!handle) {
        return;
      }


      showPageEntry(
        handle,
        trigger
      );
    }
  );


  /* direct #term link */

  const initialHandle =
    window.location.hash
      .replace('#', '')
      .trim();


  if (initialHandle) {

    showPageEntry(
      initialHandle,
      null
    );
  }
}


/* initialize glossary page */

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    setupGlossaryPage
  );

} else {

  setupGlossaryPage();
}

})();
